function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 736,
    viewBox: "0 0 525 552",
    id: "svg2647",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 110.52407,0.01240603 V 27.644204 H 55.25943 V 55.276003 L 27.631798,55.27194 V 82.903738 H 0 V 193.433 h 27.631798 v 55.26464 l 27.627632,-0.008 v 27.6318 h 27.631798 v 27.6318 h 27.631802 v 27.63179 h 27.63179 v 27.6318 h 27.6318 v 27.6318 h 27.6318 v 55.26464 h 27.6318 v 55.26464 h 27.6318 v 55.26463 h 27.6318 v -55.26463 h 27.63179 v -55.26464 h 27.6318 V 386.8483 h 27.6318 v -27.6318 h 27.6318 v -27.6318 h 27.6318 v -27.63179 h 27.6318 v -27.6318 h 27.63179 v -27.6318 h 27.6318 V 193.42467 H 525 V 82.895395 H 497.3682 V 55.263596 H 469.7364 V 27.631798 H 414.47177 V 0 h -55.26464 v 27.631798 h -55.26464 v 27.631798 h -27.6318 v 27.631799 h -27.6318 V 55.263596 h -27.6318 V 27.631798 l -27.63596,0.01221 h -27.6318 V 0.01220812 Z",
    id: "path2645",
    style: {
      strokeWidth: 1.04165
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.ca5c23b949cde1f26df65718884863d5.svg";
export { ForwardRef as ReactComponent };